import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


/**
   * Logger Factory
   * @namespace value: current value of checkbox
   * @namespace items: number of element to show
   * @namespace selectedItems: bring to the parent the value selected 
   * <ute-circle-checkbox [items]="items || [{name: 'test', value: false}]" (selectedItems)="test($event)"></ute-circle-checkbox>
*/

@Component({
  selector: 'ute-circle-checkbox',
  templateUrl: 'ute-circle-checkbox.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=> UteCircleCheckboxComponent),
    multi: true
  }]
})
export class UteCircleCheckboxComponent {
  @Input() value: string;
  @Input() items: any[];
  @Output() selectedItems= new EventEmitter;

  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public valueCheckbox: string = '';
  public innerValue: any[];
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() {
  
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }
  public writeValue(obj: any) {
    if(obj) {
      this.valueCheckbox = obj;
    } 
  }
  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  onChangeCheckbox(item){
    this.propagateChange(item);
    this.selectedItems.emit(this.items.filter((e) => (e.value === true)));
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-circle-checkbox/ute-circle-checkbox.component.ts